
export * from './apptext.module';
